// 치과 회원가입 — 처리위탁 확인 2건 가입 전용 서버 호출 (2026-10-08)
// 계약: docs/계약_처리위탁_가입기록_서버_2026-10-08.md (functions/lib/clinic-signup-delegation.js)
//   getSignupClinicDelegationVersions({}) — 공개 → { desk:{version,textHash}|null, pa:{version,textHash}|null }
//   acceptSignupClinicDelegations({ desk?, pa?, attest:true }) — 가입 직후(users setDoc 뒤)
//     → { ok, recorded, desk:{ok,version,already}|{ok:false,code}|null, pa:같은 모양|null }
//     user-not-ready(failed-precondition) = 1~2초 뒤 1회 재시도(계약 §2-2)
import { getFunctions, httpsCallable } from 'firebase/functions';

const REGION = 'asia-northeast3';
const call = (name) => httpsCallable(getFunctions(undefined, REGION), name);

export async function getSignupClinicDelegationVersions() {
    const res = await call('getSignupClinicDelegationVersions')({});
    const d = res?.data || {};
    const pick = (x) => (x && typeof x.version === 'string' && typeof x.textHash === 'string' ? { version: x.version, textHash: x.textHash } : null);
    return { desk: pick(d.desk), pa: pick(d.pa) };
}

const sleep = (ms) => new Promise(r => setTimeout(r, ms));

/**
 * 문서별 기록. 반환: { ok:boolean(전 문서 기록됨), results:{ desk?, pa? }, error? }
 * 오류는 콘솔에 코드만(이름·환자 정보 없음).
 */
export async function acceptSignupClinicDelegations(docs) {
    const body = { attest: true };
    for (const d of docs) body[d.key] = { version: d.version, textHash: d.textHash };
    const fn = call('acceptSignupClinicDelegations');
    let lastErr = null;
    for (let attempt = 0; attempt < 2; attempt++) {
        try {
            const res = await fn(body);
            const r = res?.data || {};
            const results = {};
            let allOk = r.ok === true;
            for (const d of docs) {
                results[d.key] = r[d.key] || null;
                if (!(r[d.key] && r[d.key].ok === true)) {
                    allOk = false;
                    console.error(`[가입 처리위탁 기록] ${d.version} 기록 안 됨:`, r[d.key]?.code || 'no-result');
                }
            }
            return { ok: allOk, results };
        } catch (e) {
            lastErr = e;
            const detail = e?.details?.code;
            console.error('[가입 처리위탁 기록] 호출 실패:', e?.code || e?.message || e, detail || '', `시도 ${attempt + 1}`);
            if (detail === 'user-not-ready' && attempt === 0) { await sleep(1500); continue; }
            break;
        }
    }
    return { ok: false, results: {}, error: lastErr?.details?.code || lastErr?.code || 'call-failed' };
}
